<div
  [ngClass]="{
    container: !isSidenavVersion,
    'container-simplified': isSidenavVersion,
    'mcompanion-mode': isCompanion
  }"
>
  <div class="header-topline__mobile" test-target="header-topline__mobile">
    <div
      class="header__logo"
      [ngClass]="{ 'header__logo--sidenav': isSidenavVersion }"
      test-target="header-topline__logo__mobile"
    >
      <a [mmTestTarget]="'home-link--mobile'" [href]="headerLogoLink" (click)="onLogoClick()">
        <span class="sr-only">{{'HEADER.ALL_PAGES.HEADER.LOGO.ALT.TEXT' | translate}} home page</span>
        <mm-icon
          class="logo-icon"
          [ngClass]="{ 'logo-icon--sidenav': isSidenavVersion }"
          [name]="headerLogoName"
        ></mm-icon>
      </a>
    </div>
    <div class="user-box" [ngClass]="{ 'user-box--sidenav': isSidenavVersion }">
      <ng-container *ngIf="byPassfeatureFlag || !(isGtTablet | async)">
        <ng-container
          *ngIf="
            (accountType$ | async) === 'employee' || (accountType$ | async) === 'employee_as_customer';
            else customerUserBox
          "
        >
          <app-employee-profile-box></app-employee-profile-box>
        </ng-container>
        <ng-template #customerUserBox>
          <app-generic-user-box [user]="user" [isMobileView]="true"></app-generic-user-box>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div
    fxFlex="100"
    fxHide.mm-desktop="true"
    fxHide.mm-tablet-landscape="true"
    class="header-topline__mobile__exlinks"
    *ngIf="!isSidenavVersion && showHeaderTopline"
  >
    <app-external-links [mmTestTarget]="'header-external-links'"></app-external-links>
  </div>
  <div class="header-topline" fxFlex="100">
    <div class="header__logo" test-target="header-topline__logo__desktop" fxFlex="10">
      <a [mmTestTarget]="'home-link'" [href]="headerLogoLink" (click)="onLogoClick()">
        <span class="sr-only">{{'HEADER.ALL_PAGES.HEADER.LOGO.ALT.TEXT' | translate}} home page</span>
        <mm-icon class="logo-icon" [name]="headerLogoName"></mm-icon>
      </a>
    </div>
    <div fxFlex="55" class="header-topline__mobile__exlinks" *ngIf="showHeaderTopline && !isSidenavVersion">
      <app-external-links [mmTestTarget]="'header-external-links__desktop'"></app-external-links>
    </div>
    <div
      fxFlex="35"
      [style.max-width.px]="163.5"
      class="user-box"
      [ngClass]="{ 'user-box--sidenav': isSidenavVersion }"
    >
      <ng-container *ngIf="byPassfeatureFlag || (isGtTablet | async)">
        <ng-container
          *ngIf="
            (accountType$ | async) === 'employee' || (accountType$ | async) === 'employee_as_customer';
            else customerUserBox
          "
        >
          <app-employee-profile-box></app-employee-profile-box>
        </ng-container>
        <ng-template #customerUserBox>
          <app-generic-user-box [user]="user" [isMobileView]="false"></app-generic-user-box>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
